// components
import WeglotIntegration from "../Components/WeglotIntegration/WeglotIntegration";
const WeglotIntegrationPage = () => {
    return (
        <WeglotIntegration />
    )
}
export default WeglotIntegrationPage;